module.exports = __webpack_public_path__ + "img/icon-folder-light-black.90358549.svg";